import { render, staticRenderFns } from "./TireSizeSelectorItem.vue?vue&type=template&id=586ba3d1&"
import script from "./TireSizeSelectorItem.controller.js?vue&type=script&lang=js&"
export * from "./TireSizeSelectorItem.controller.js?vue&type=script&lang=js&"
import style0 from "./TireSizeSelectorItem.styles.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports